export const BALANCE_KEY = {
  ACCOUNT_BALANCE: 'accountBalance',
  ACCOUNT_BALANCES: 'accountBalances',
  BALANCE: 'balance'
};
